import { render, staticRenderFns } from "./brands-list.vue?vue&type=template&id=3553c096"
import script from "./brands-list.vue?vue&type=script&lang=js"
export * from "./brands-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports